export const leftMenuWidth = "230px"
export const rightMarginMessage = 0;

export const zIndex999998 = '999998';
export const zIndex1299 = '1299';
export const zIndex100 = '100';
export const zIndex3 = '3';
export const zIndexMinus1000 = '-1000';